import { render } from "./CardInner.vue?vue&type=template&id=aa1764d6"
import script from "./CardInner.vue?vue&type=script&lang=js"
export * from "./CardInner.vue?vue&type=script&lang=js"
script.render = render

export default script